import { Component, OnInit } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { EvsAddressService } from "../../../../common/services/EvsAddress.service";
declare var $: any;

@Component({
  selector: "distribution2-modal-content",
  templateUrl: "./modalDistribution2.template.html",
  styles: [],
})
export class ModalDistribution2Component implements OnInit {
  public cities: Array<any> = [];
  public districts: Array<any> = [];

  constructor(
    public bsModalRef: BsModalRef,
    public addressService: EvsAddressService
  ) {}

  ngOnInit() {}
  //   let that = this;
  //   // init select city & district
  //   let province = $("#modalProvince");
  //   let districts = $("#modalDistrict");
  //   province.select2({ placeholder: "-- Tỉnh/TP --", allowClear: false });
  //   districts.select2({ placeholder: "-- Quận/Huyện --", allowClear: false });
  //   province.on("select2:select", function (e) {
  //     let id = e.target.value;
  //     that.loadDistrictData(id);
  //   });
  //   this.getCity();
  // }

  // getCity() {
  //   this.addressService.getCities().subscribe((res) => {
  //     let citiesList = [];
  //     res.data.cities.forEach((c: any) => {
  //       citiesList.push({
  //         value: c.name,
  //         label: c.name,
  //         id: c.id,
  //       });
  //     });
  //     this.cities = citiesList;
  //   });
  // }

  // loadDistrictData(id: number) {
  //   this.addressService
  //     .getDistrict({ city_id: id })
  //     .toPromise()
  //     .then((res) => {
  //       let districts = [];
  //       res.data.districts.forEach((c: any) => {
  //         districts.push({
  //           value: c.name,
  //           label: c.name,
  //           id: c.id,
  //         });
  //       });
  //       this.districts = districts;
  //     });
  // }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/modalDistribution2.component.ts